import React from 'react';
import PropTypes from 'prop-types';
import Icon, { IconSizes, IconVariants } from '../../../../components/foundations/Icon';
import { WarningMessage } from '../../../../components/widgets';
import CreativePreview from '../../../../components/creatives/CreativePreview';
import css from './SuggestionItem.css';
import withTranslate from '../../../../containers/widgets/withTranslate';
import { INSIGHTS_KEY_PREFIX } from '../consts';

const SuggestionItem = ({ creativeData, index, translate }) => {
    try {
        const { creative_id: creativeId, url, suggestions: creativeSuggestions = [] } = creativeData || {};

        return (
            <div key={`creative-${creativeId || index}`} className={css.creativeContainer}>
                <div className={css.creativeDisplay}>
                    <div className={css.creativeMedia}>
                        <CreativePreview url={url || ''} />
                    </div>
                </div>
                <div className={css.suggestionsContainer}>
                    {creativeSuggestions.map((suggestionItem, suggestionIndex) => {
                        const { suggestion = '', expected_outcome: expectedOutcome = '' } = suggestionItem || {};

                        return (
                            <div key={`suggestion-${index}-${suggestionIndex}`} className={css.suggestionItem}>
                                <div className={css.suggestionText}>{suggestion}</div>
                                <div className={css.expectedOutcome}>
                                    <Icon
                                        name="ai-line"
                                        size={IconSizes.X_SMALL}
                                        variant={IconVariants.LIGHT}
                                        className={css.outcomeIcon}
                                    />
                                    <span className={css.outcomeText}>
                                        {translate(`${INSIGHTS_KEY_PREFIX}.EXPECTED_OUTCOME`)}: {expectedOutcome}
                                    </span>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    } catch (error) {
        console.error(`Error rendering suggestion item at index ${index}:`, error);
        return (
            <div key={`error-suggestion-${index}`} className={css.errorRow}>
                <WarningMessage showIcon message="Error displaying suggestion" className={css.rowError} />
            </div>
        );
    }
};

SuggestionItem.propTypes = {
    creativeData: PropTypes.shape({
        creative_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        url: PropTypes.string,
        suggestions: PropTypes.array,
    }),
    index: PropTypes.number.isRequired,
    translate: PropTypes.func,
};

export default withTranslate(SuggestionItem);
